import React, { useState } from 'react';
import FooterDrawer from '@/components/ui/atoms/FooterDrawer';
import { IconCheck } from '@tabler/icons-react';
import { relationshipOptionsForAddMember, RelationshipType } from '@/types/relationship';
import styles from './MGender.module.css';

export interface MRelationshipProps {
  open: boolean;
  onClose: () => void;
  onDone: (relationship: RelationshipType) => void;
  initialValue?: RelationshipType;
  title?: string;
  options?: { label: string; value: RelationshipType }[];
}

export const MRelationship: React.FC<MRelationshipProps> = ({
  open,
  onClose,
  onDone,
  initialValue,
  title = 'Select Relationship',
  options,
}) => {
  const relationshipOptions = options || relationshipOptionsForAddMember;
  const [selected, setSelected] = useState<RelationshipType | undefined>(initialValue);

  const handleSelect = (relationship: RelationshipType) => {
    setSelected(relationship);
    onDone(relationship);
  };

  return (
    <FooterDrawer
      open={open}
      onClose={onClose}
      title={title}
      showClose={true}
      onDone={undefined}
      height="auto"
    >
      <div className={styles.genderWrap}>
        {relationshipOptions.map((option) => (
          <div
            key={option.value}
            className={`${styles.genderOption} ${selected === option.value ? styles.selected : ''}`}
            onClick={() => handleSelect(option.value)}
            role="button"
            tabIndex={0}
            aria-selected={selected === option.value}
          >
            <div className={styles.genderLabel}>{option.label}</div>
            {selected === option.value && <IconCheck size={24} className={styles.checkmark} />}
          </div>
        ))}
      </div>
    </FooterDrawer>
  );
};

export default MRelationship;
